<template>
  <div class="login-container" :class="'theme-' + currentTheme">
    <div class="left">
      <!-- ===== 테마1: 하늘 거북이 ===== -->
      <template v-if="currentTheme === 'turtle'">
        <div class="sky-bg"></div>
        <div class="cloud-layer">
          <div v-for="n in 18" :key="'cloud-' + n"
               class="cloud-particle"
               :style="getCloudStyle(n)">
          </div>
        </div>
        <img src="/gif/fly_turtle2.gif" class="theme-character turtle-character"/>
      </template>

      <!-- ===== 테마2: 킥보드 토끼 (석양 공원) ===== -->
      <template v-if="currentTheme === 'rabbit'">
        <div class="sunset-scene">
          <!-- 하늘 그라데이션 -->
          <div class="sunset-sky"></div>
          <!-- 해 -->
          <div class="sunset-sun"></div>
          <!-- 구름 -->
          <div class="sunset-cloud sunset-cloud-1"></div>
          <div class="sunset-cloud sunset-cloud-2"></div>
          <div class="sunset-cloud sunset-cloud-3"></div>
          <!-- 뒷 산/언덕 -->
          <div class="sunset-hills"></div>
          <!-- 나무 레이어 (스크롤) -->
          <div class="sunset-trees-layer">
            <div class="sunset-trees-track">
              <div class="sunset-tree-set" v-for="copy in 2" :key="'tree-' + copy">
                <div v-for="n in 10" :key="'t-' + copy + '-' + n"
                     class="sunset-tree"
                     :style="getTreeStyle(n)">
                  <div class="tree-trunk"></div>
                  <div class="tree-crown"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 길 -->
          <div class="sunset-path">
            <div class="path-surface"></div>
            <div class="path-dashes">
              <div class="path-dash-track">
                <div v-for="n in 30" :key="'pd-' + n" class="path-dash"></div>
              </div>
            </div>
          </div>
          <!-- 캐릭터 -->
          <img src="/gif/kickboard_hare.gif" class="theme-character rabbit-character"/>
        </div>
      </template>

      <!-- ===== 테마3: 드라이빙 카 + 까마귀 ===== -->
      <template v-if="currentTheme === 'car'">
        <div class="side-scroll-scene">
          <!-- 하늘 -->
          <div class="ss-sky">
            <div class="ss-stars"></div>
            <div class="ss-moon"></div>
          </div>

          <!-- 뒷 건물 (느리게 스크롤) -->
          <div class="ss-buildings-far">
            <div class="ss-buildings-track ss-far-track">
              <div class="ss-building-set" v-for="copy in 2" :key="'far-copy-' + copy">
                <div v-for="n in 16" :key="'far-b-' + copy + '-' + n"
                     class="ss-building ss-building-far-item"
                     :style="getFarBuildingStyle(n)">
                  <div class="ss-building-windows">
                    <div v-for="w in getBuildingWindows(n, 'far')" :key="'fw-' + copy + '-' + n + '-' + w"
                         class="ss-window"
                         :style="{ opacity: ((n * 7 + w * 3) % 10) > 3 ? 0.85 : 0.15 }">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 앞 건물 (빠르게 스크롤) -->
          <div class="ss-buildings-near">
            <div class="ss-buildings-track ss-near-track">
              <div class="ss-building-set" v-for="copy in 2" :key="'near-copy-' + copy">
                <div v-for="n in 12" :key="'near-b-' + copy + '-' + n"
                     class="ss-building ss-building-near-item"
                     :style="getNearBuildingStyle(n)">
                  <div class="ss-building-windows">
                    <div v-for="w in getBuildingWindows(n, 'near')" :key="'nw-' + copy + '-' + n + '-' + w"
                         class="ss-window ss-window-near"
                         :style="{ opacity: ((n * 5 + w * 7) % 10) > 4 ? 0.9 : 0.1 }">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 가로등 -->
          <div class="ss-props-layer">
            <div class="ss-props-track">
              <div class="ss-prop-set" v-for="copy in 2" :key="'lamp-copy-' + copy">
                <div v-for="n in 6" :key="'lamp-' + copy + '-' + n" class="ss-lamp"
                     :style="{ left: ((n - 1) * 16.6 + 4) + '%' }">
                  <div class="ss-lamp-post"></div>
                  <div class="ss-lamp-head"></div>
                  <div class="ss-lamp-glow"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 도로 -->
          <div class="ss-road">
            <div class="ss-road-top-line"></div>
            <div class="ss-road-dashes">
              <div class="ss-dash-track">
                <div v-for="n in 40" :key="'dash-' + n" class="ss-dash"></div>
              </div>
            </div>
            <div class="ss-road-bottom-line"></div>
            <div class="ss-sidewalk"></div>
          </div>

          <!-- 캐릭터 -->
          <img src="/gif/car_driving.gif" class="theme-character driving-car"/>
          <img src="/gif/fly_crow.gif" class="theme-character fly-crow"/>
        </div>
      </template>

      <div class="title-content">
        <h2>언제나 당신의<br>영업 파트너</h2>
        <p>보다</p>
      </div>
    </div>
    <div class="right">
      <div class="login-pager">
        <div class="login-pager-logo">
          <img src="/imgs/LOGO.png" alt="Logo" />
        </div>
        <h2>보험인의 다이어리 "보다"</h2>
        <p v-if="alert_visible" class="alert"> <i class="ph ph-warning-circle"></i> {{ alert_content }}</p>
        <div id="loginForm">
          <form @submit.prevent="fnLogin">
            <label for="uid">아이디</label>
            <input class="w3-input" name="uid" placeholder="아이디 입력" v-model="user_id">
            <label for="password">비밀번호</label>
            <input name="password" class="w3-input" placeholder="비밀번호 입력" v-model="user_pw" type="password" autocomplete="new-password">
            <button type="submit" class="w3-button w3-green w3-round">로그인</button>
          </form>
        </div>
        <p> 
          <a style="color:var(--color-brand); cursor:pointer;" @click="openBodaLogin">카카오/네이버 로그인</a>
          <br>회원이 아니신가요? <a href="https://amadiary.com/bbs/register_form.php">AMA로 회원가입</a>
        </p>
        <p><a href="https://amadiary.com/bbs/password_lost.php">비밀번호 찾기</a></p>
        <p><a style="color:var(--color-text-secondary); text-decoration: underline;" href="/terms">이용약관</a> <a style="color:var(--color-text-secondary); text-decoration: underline;" href="/terms?tab=privacy">개인정보처리방침</a> </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import { useAuth } from "@/composables/useAuth";

export default {
  methods: {
    showAlert(message) {
      this.alert_visible = true;
      this.alert_content = message;
      window.gsap.from(".alert", { duration: 0.5, scale: 1.1, ease: "power2.out" });
    },
    async fnLogin() {
      if (this.user_id === "") {
        this.showAlert("ID를 입력하세요.");
        return;
      }
      if (this.user_pw === "") {
        this.showAlert("비밀번호를 입력하세요.");
        return;
      }
      const login_value = await this.login_test(this.user_id, this.user_pw);
      if (login_value.success === true) {
        this.showLoading(true);
        location.replace("/");
      } else {
        this.showAlert("권한이 없거나, 아이디 또는 비밀번호가 틀립니다.");
      }
    },
  },
  setup() {
    const alert_visible = ref(false);
    const alert_content = ref("");

    // ========== 번갈아가며 테마 선택 (3개 순환) ==========
    const themes = ['turtle', 'rabbit', 'car'];
    const last = localStorage.getItem('login_theme');
    const lastIdx = themes.indexOf(last);
    const next = themes[(lastIdx + 1) % themes.length];
    localStorage.setItem('login_theme', next);
    const currentTheme = ref(next);

    const user_id = ref("");
    const user_pw = ref("");

    const login_test = inject("login_test");
    const showLoading = inject("showLoading");
    const isLoggedIn = inject("isLoggedIn");
    const { openLoginPopup, checkUrlToken } = useAuth();

    // 구름 파티클 스타일 (거북이 테마)
    const getCloudStyle = (n) => {
      const sizes = [60, 80, 100, 50, 120, 70, 90, 110, 65, 85, 95, 75, 105, 55, 130, 68, 88, 115];
      const size = sizes[(n - 1) % sizes.length];
      const left = ((n * 37 + 13) % 90) + 5;
      const delay = ((n * 1.7 + 0.3) % 12);
      const duration = 8 + (n % 5) * 2;
      const opacity = 0.4 + (n % 4) * 0.15;
      return {
        width: size + 'px',
        height: (size * 0.6) + 'px',
        left: left + '%',
        animationDelay: delay + 's',
        animationDuration: duration + 's',
        opacity: opacity,
      };
    };

    // 뒷 건물 스타일
    const getFarBuildingStyle = (n) => {
      const heights = [50, 80, 40, 95, 60, 45, 100, 55, 75, 35, 85, 65, 70, 50, 90, 58];
      const widths =  [30, 40, 25, 45, 35, 28, 42, 32, 38, 24, 44, 34, 36, 30, 40, 33];
      const colors = ['#3a3a5c', '#44446e', '#353560', '#4a4a78', '#3e3e68', '#484880'];
      return {
        height: heights[(n - 1) % 16] + 'px',
        width: widths[(n - 1) % 16] + 'px',
        backgroundColor: colors[(n - 1) % colors.length],
        flexShrink: 0,
      };
    };

    // 앞 건물 스타일
    const getNearBuildingStyle = (n) => {
      const heights = [90, 140, 70, 160, 110, 80, 180, 100, 130, 65, 150, 95];
      const widths =  [50, 65, 40, 75, 55, 45, 70, 48, 60, 38, 72, 52];
      const colors = ['#1e1e38', '#262648', '#1a1a32', '#2a2a50', '#222244', '#282858'];
      return {
        height: heights[(n - 1) % 12] + 'px',
        width: widths[(n - 1) % 12] + 'px',
        backgroundColor: colors[(n - 1) % colors.length],
        flexShrink: 0,
      };
    };

    const getBuildingWindows = (n, type) => {
      if (type === 'far') return 2 + (n % 3) * 2;
      return 4 + (n % 4) * 2;
    };

    // 석양 나무 스타일 (rabbit 테마)
    const getTreeStyle = (n) => {
      const heights = [80, 120, 60, 140, 90, 70, 130, 75, 110, 100];
      const trunkH = [25, 35, 20, 40, 28, 22, 38, 24, 32, 30];
      const crownW = [40, 55, 35, 60, 45, 38, 58, 42, 50, 48];
      return {
        '--tree-height': heights[(n-1) % 10] + 'px',
        '--trunk-height': trunkH[(n-1) % 10] + 'px',
        '--crown-width': crownW[(n-1) % 10] + 'px',
        flexShrink: 0,
        marginRight: (12 + (n * 7) % 20) + 'px',
      };
    };

    const openBodaLogin = () => {
      openLoginPopup(
        (data) => { console.log(data); showLoading(true); location.replace("/"); },
        (message) => { alert(message || '로그인 실패'); }
      );
    };

    onMounted(() => {
      checkUrlToken(
        () => { showLoading(true); location.replace("/"); },
        (message) => { alert(message); }
      );
      if (isLoggedIn()) { location.replace("/"); }
    });

    return {
      alert_visible, alert_content, user_id, user_pw,
      login_test, showLoading, currentTheme,
      getCloudStyle, getFarBuildingStyle, getNearBuildingStyle, getBuildingWindows, getTreeStyle,
      openBodaLogin
    };
  },
};
</script>

<style scoped>

/* ===================================
   공통 레이아웃
   =================================== */

.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.left {
  position: relative;
  width: 55%;
  height: 100%;
  overflow: hidden;
}

.right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-character {
  position: absolute;
  z-index: 10;
  will-change: transform;
  backface-visibility: hidden;
}

.title-content {
  position: absolute;
  left: 12%;
  top: 36%;
  line-height: 80px;
  z-index: 20;
}

.title-content h2 {
  font-size: var(--font-size-6xl);
  font-weight: 700;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, .4);
  padding: 0; margin: 0;
  font-family: 'SchoolSafetyRoundedSmile', sans-serif;
  color: #fff;
}

.title-content p {
  font-size: var(--font-size-6xl);
  font-weight: 900;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, .4);
  padding: 0; margin: 0;
  color: var(--color-brand);
  font-family: 'SchoolSafetyRoundedSmile', sans-serif;
}


/* ===================================
   테마1: 하늘 거북이
   =================================== */

.theme-turtle .left {
  background: linear-gradient(180deg, #87CEEB 0%, #b8e4f9 40%, #e0f4ff 100%);
}

.sky-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, #4da6d9 0%, #87CEEB 30%, #b8e4f9 60%, #e8f6ff 100%);
}

.cloud-layer {
  position: absolute;
  inset: 0;
  z-index: 5;
  pointer-events: none;
}

.cloud-particle {
  position: absolute;
  top: -120px;
  background: white;
  border-radius: 50%;
  box-shadow:
    0 0 20px rgba(255,255,255,0.8),
    20px 10px 0 rgba(255,255,255,0.9),
    -15px 5px 0 rgba(255,255,255,0.85),
    10px -5px 0 rgba(255,255,255,0.9);
  animation: cloudFall linear infinite;
  filter: blur(1px);
}

@keyframes cloudFall {
  0%   { transform: translateY(-20px) scale(0.8); opacity: 0; }
  10%  { opacity: 0.6; }
  90%  { opacity: 0.6; }
  100% { transform: translateY(calc(100vh + 120px)) scale(1.1); opacity: 0; }
}

.turtle-character {
  height: 700px; width: 700px;
  left: 45%; top: 16%;
  animation: turtleFloat 6s cubic-bezier(.22,.9,.27,.99) infinite;
}

@keyframes turtleFloat {
  0%   { transform: translate3d(0, 0, 0) rotate(0deg) scale(1); }
  12%  { transform: translate3d(18px, -28px, 0) rotate(1.2deg) scale(1.01); }
  25%  { transform: translate3d(30px, -40px, 0) rotate(2deg) scale(1.02); }
  37%  { transform: translate3d(10px, -50px, 0) rotate(1deg) scale(1.015); }
  50%  { transform: translate3d(-20px, -60px, 0) rotate(-1deg) scale(1.01); }
  63%  { transform: translate3d(-32px, -30px, 0) rotate(-1.5deg) scale(1.005); }
  75%  { transform: translate3d(-40px, -20px, 0) rotate(-0.5deg) scale(1); }
  88%  { transform: translate3d(-15px, -10px, 0) rotate(0.6deg) scale(0.995); }
  100% { transform: translate3d(0, 0, 0) rotate(0deg) scale(1); }
}


/* ===================================
   테마2: 석양 공원 토끼
   =================================== */

.theme-rabbit .left {
  background: linear-gradient(180deg, #1a0533 0%, #4a1942 15%, #c84b31 40%, #f4a261 60%, #f7d794 80%, #fef9ef 100%);
}

.sunset-scene {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.sunset-sky {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, #1a0533 0%, #4a1942 15%, #c84b31 40%, #f4a261 60%, #f7d794 80%, #fef9ef 100%);
}

/* 해 */
.sunset-sun {
  position: absolute;
  bottom: 32%;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, #fff7e0 0%, #ffd166 40%, #f4a261 70%, transparent 100%);
  border-radius: 50%;
  box-shadow: 0 0 60px rgba(255,209,102,0.6), 0 0 120px rgba(244,162,97,0.3);
}

/* 구름 */
.sunset-cloud {
  position: absolute;
  background: rgba(255,255,255,0.15);
  border-radius: 50%;
  filter: blur(4px);
}

.sunset-cloud-1 {
  width: 200px; height: 40px;
  top: 18%; left: 10%;
  animation: cloudDrift 25s linear infinite;
}

.sunset-cloud-2 {
  width: 160px; height: 30px;
  top: 25%; left: 55%;
  animation: cloudDrift 30s linear infinite reverse;
}

.sunset-cloud-3 {
  width: 120px; height: 25px;
  top: 12%; left: 35%;
  animation: cloudDrift 20s linear infinite;
}

@keyframes cloudDrift {
  0%   { transform: translateX(-20px); opacity: 0.15; }
  50%  { opacity: 0.25; }
  100% { transform: translateX(20px); opacity: 0.15; }
}

/* 뒷 언덕 */
.sunset-hills {
  position: absolute;
  bottom: 25%;
  left: 0; right: 0;
  height: 100px;
  background:
    radial-gradient(ellipse 50% 80% at 20% 100%, #2d1b4e 70%, transparent 71%),
    radial-gradient(ellipse 40% 90% at 50% 100%, #3a2260 70%, transparent 71%),
    radial-gradient(ellipse 55% 70% at 80% 100%, #2d1b4e 70%, transparent 71%);
}

/* 나무 레이어 */
.sunset-trees-layer {
  position: absolute;
  bottom: 18%;
  left: 0; right: 0;
  height: 160px;
  z-index: 3;
  overflow: hidden;
  pointer-events: none;
}

.sunset-trees-track {
  display: flex;
  width: fit-content;
  animation: treeScroll 18s linear infinite;
}

.sunset-tree-set {
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
}

.sunset-tree {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: var(--tree-height, 100px);
  justify-content: flex-end;
}

.tree-trunk {
  width: 6px;
  height: var(--trunk-height, 30px);
  background: #1a0e2e;
  border-radius: 2px;
}

.tree-crown {
  width: var(--crown-width, 45px);
  aspect-ratio: 1;
  background: radial-gradient(ellipse at 50% 60%, #1a0e2e 60%, transparent 61%);
  margin-bottom: -4px;
  order: -1;
}

@keyframes treeScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* 길 */
.sunset-path {
  position: absolute;
  bottom: 0;
  left: 0; right: 0;
  height: 18%;
  z-index: 4;
}

.path-surface {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, #8b7355 0%, #a0896a 50%, #9e8c70 100%);
  border-top: 3px solid #6b5a42;
}

.path-dashes {
  position: absolute;
  top: 50%;
  left: 0; right: 0;
  height: 4px;
  transform: translateY(-50%);
  overflow: hidden;
}

.path-dash-track {
  display: flex;
  gap: 30px;
  width: fit-content;
  animation: dashScroll 4s linear infinite;
}

.path-dash {
  width: 35px; height: 4px;
  background: rgba(255,255,255,0.3);
  border-radius: 2px;
  flex-shrink: 0;
}

/* 킥보드 토끼 캐릭터 */
.rabbit-character {
  width: 400px; height: 400px;
  left: 42%; bottom: 1%;
  z-index: 10;
  transform: scaleX(-1);
  animation: rabbitRide 0.6s ease-in-out infinite;
}

@keyframes rabbitRide {
  0%, 100% { transform: scaleX(-1) translateY(0) rotate(0deg); }
  25%      { transform: scaleX(-1) translateY(-5px) rotate(-0.4deg); }
  75%      { transform: scaleX(-1) translateY(-2px) rotate(0.3deg); }
}


/* ===================================
   테마3: 드라이빙 카 + 까마귀
   =================================== */

.theme-car .left {
  background: #0f0c29;
}

.side-scroll-scene {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

/* ---- 하늘 ---- */
.ss-sky {
  position: absolute;
  top: 0; left: 0; right: 0;
  bottom: 0;
  background: linear-gradient(180deg, #0f0c29 0%, #1a1640 30%, #302b63 70%, #443a8a 100%);
}

.ss-stars {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(1px 1px at 5% 15%, #fff 100%, transparent),
    radial-gradient(1.5px 1.5px at 12% 42%, #fff 100%, transparent),
    radial-gradient(1px 1px at 22% 8%, #fff 100%, transparent),
    radial-gradient(2px 2px at 35% 55%, #ffd 100%, transparent),
    radial-gradient(1px 1px at 45% 22%, #fff 100%, transparent),
    radial-gradient(1.5px 1.5px at 55% 38%, #fff 100%, transparent),
    radial-gradient(1px 1px at 65% 12%, #fff 100%, transparent),
    radial-gradient(1px 1px at 78% 48%, #fff 100%, transparent),
    radial-gradient(2px 2px at 88% 25%, #ffd 100%, transparent),
    radial-gradient(1px 1px at 92% 60%, #fff 100%, transparent),
    radial-gradient(1px 1px at 18% 65%, #fff 100%, transparent),
    radial-gradient(1.5px 1.5px at 42% 5%, #fff 100%, transparent),
    radial-gradient(1px 1px at 72% 2%, #fff 100%, transparent);
  animation: starTwinkle 3s ease-in-out infinite alternate;
}

@keyframes starTwinkle {
  0% { opacity: 0.5; }
  100% { opacity: 1; }
}

.ss-moon {
  position: absolute;
  top: 10%; right: 18%;
  width: 50px; height: 50px;
  background: #fffde7;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(255,253,200,0.6), 0 0 60px rgba(255,253,200,0.2);
}

/* ---- 건물 공통 ---- */
.ss-buildings-far,
.ss-buildings-near {
  position: absolute;
  left: 0; right: 0;
  overflow: hidden;
}

.ss-buildings-track {
  display: flex;
  width: fit-content;
}

.ss-building-set {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
  padding-right: 6px;
}

.ss-building {
  border-radius: 2px 2px 0 0;
  position: relative;
}

.ss-building-windows {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 6px 4px;
  justify-content: center;
}

.ss-window {
  width: 5px; height: 6px;
  background: #ffd700;
  border-radius: 1px;
}

.ss-window-near {
  width: 7px; height: 9px;
}

/* 뒷 건물: 느리게 */
.ss-buildings-far {
  bottom: 28%;
  height: 120px;
  z-index: 2;
}

.ss-far-track {
  animation: scrollLeftFar 35s linear infinite;
}

/* 앞 건물: 빠르게 */
.ss-buildings-near {
  bottom: 18%;
  height: 200px;
  z-index: 3;
}

.ss-near-track {
  animation: scrollLeftNear 20s linear infinite;
}

@keyframes scrollLeftFar {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@keyframes scrollLeftNear {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* ---- 가로등 ---- */
.ss-props-layer {
  position: absolute;
  bottom: 18%;
  left: 0; right: 0;
  height: 100px;
  z-index: 5;
  overflow: hidden;
  pointer-events: none;
}

.ss-props-track {
  display: flex;
  width: fit-content;
  animation: scrollLeftProps 14s linear infinite;
}

@keyframes scrollLeftProps {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.ss-prop-set {
  position: relative;
  width: 100vw;
  flex-shrink: 0;
  height: 100px;
}

.ss-lamp {
  position: absolute;
  bottom: 0;
}

.ss-lamp-post {
  width: 4px; height: 70px;
  background: #666;
  margin: 0 auto;
  border-radius: 2px;
}

.ss-lamp-head {
  width: 18px; height: 6px;
  background: #888;
  border-radius: 3px;
  margin: 0 auto;
  position: relative;
  top: -76px;
}

.ss-lamp-glow {
  width: 50px; height: 60px;
  background: radial-gradient(ellipse at top, rgba(255,220,100,0.25) 0%, transparent 70%);
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  top: -76px;
}

/* ---- 도로 (화면 하단 가로) ---- */
.ss-road {
  position: absolute;
  bottom: 0;
  left: 0; right: 0;
  height: 18%;
  z-index: 4;
  background: #2a2a2a;
}

.ss-road-top-line {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 4px;
  background: #ddd;
}

.ss-road-bottom-line {
  position: absolute;
  bottom: 22px; left: 0; right: 0;
  height: 4px;
  background: #ddd;
}

.ss-sidewalk {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 22px;
  background: repeating-linear-gradient(
    90deg,
    #5a5a5a 0px,
    #5a5a5a 30px,
    #666 30px,
    #666 32px
  );
  border-top: 2px solid #888;
}

/* 도로 점선 (가로 이동) */
.ss-road-dashes {
  position: absolute;
  top: 50%;
  left: 0; right: 0;
  height: 6px;
  transform: translateY(-50%);
  overflow: hidden;
}

.ss-dash-track {
  display: flex;
  gap: 30px;
  width: fit-content;
  animation: dashScroll 4s linear infinite;
}

.ss-dash {
  width: 40px; height: 6px;
  background: #f5c542;
  border-radius: 2px;
  flex-shrink: 0;
}

@keyframes dashScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(calc(-50% - 15px)); }
}

/* ---- 자동차 캐릭터 ---- */
.driving-car {
  aspect-ratio: 16/8.5;
  height: auto;
  width: 1000px;
  left: 15%;
  bottom: -5%;
  z-index: 15;
  animation: drivingCar 1.2s ease-in-out infinite;
}

@keyframes drivingCar {
  0%   { transform: translateY(0) rotate(0deg); }
  15%  { transform: translateY(-4px) rotate(-0.2deg); }
  30%  { transform: translateY(-7px) rotate(-0.4deg); }
  50%  { transform: translateY(-3px) rotate(0.1deg); }
  70%  { transform: translateY(-6px) rotate(-0.2deg); }
  85%  { transform: translateY(-2px) rotate(0.15deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

/* ---- 까마귀 ---- */
.fly-crow {
  aspect-ratio: 1/1;
  height: auto;
  width: 200px;
  left: 55%;
  bottom: 45%;
  z-index: 16;
  animation: crowFly 8s ease-in-out infinite;
}

@keyframes crowFly {
  0%   { transform: translate(0, 0) rotate(0deg); }
  15%  { transform: translate(30px, -25px) rotate(3deg); }
  30%  { transform: translate(50px, -10px) rotate(-2deg); }
  50%  { transform: translate(20px, -40px) rotate(4deg); }
  65%  { transform: translate(-15px, -20px) rotate(-3deg); }
  80%  { transform: translate(-30px, -35px) rotate(2deg); }
  100% { transform: translate(0, 0) rotate(0deg); }
}

/* ===================================
   로그인 폼 (기존 유지)
   =================================== */

.login-container .login-pager {
  width: 100%;
  max-width: var(--break-point-480);
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--font-size-xl);
  border-radius: var(--font-size-xl);
  background: var(--color-background);
}

.login-container .login-pager .login-pager-logo > img {
  width: var(--font-size-3xl);
  height: var(--font-size-3xl);
  object-fit: cover;
}

.login-container .login-pager > h2 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  text-align: center;
}

.login-container .login-pager > h2 > small {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-normal);
  color: var(--color-text-primary);
  opacity: 0.5;
}

.login-container .login-pager #loginForm {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-md);
}

.login-container .login-pager #loginForm > form {
  position: relative;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-md);
  box-sizing: border-box;
}

.login-container .login-pager #loginForm > form > input {
  width: 100%;
  padding: var(--font-size-xl);
  height: var(--font-size-5xl);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  border: solid var(--color-text-secondary) 1px;
  border-radius: var(--font-size-md);
  background-color: var(--color-primary);
  margin: 0;
  box-sizing: border-box;
}

.login-container .login-pager #loginForm > form > input:focus {
  outline: none;
  border: solid var(--color-brand) 1px;
  box-shadow: 0px 0px 5px var(--color-brand);
}

.login-container .login-pager .alert {
  width: 100%;
  font-size: var(--font-size-md);
  color: var(--color-special-warning);
}

.login-container .login-pager #loginForm > form > label {
  width: 100%;
  font-size: var(--font-size-md);
}

.login-container .login-pager #loginForm > form > button {
  width: 100%;
  height: var(--font-size-5xl);
  border-radius: 100px;
  margin: 0; border: 0;
  font-size: var(--font-size-xl);
  font-weight: 600;
  margin-top: var(--font-size-xl);
  background-color: var(--color-brand);
  color: #fff;
  cursor: pointer;
}

.login-container .login-pager .login-pager-footer {
  margin-top: var(--font-size-xl);
}

.login-container .login-pager .login-pager-footer p {
  padding: 0; margin: 0;
}


/* ===================================
   반응형
   =================================== */

@media screen and (max-width: 1600px) {
  .turtle-character { left: 26%; top: 16%; }
  .driving-car { width: 900px; left: 0%; }
  .rabbit-character { left: 34%; }
  .title-content { left: 10%; }
  .title-content h2 { font-size: var(--font-size-5xl) !important; }
  .title-content p { font-size: var(--font-size-5xl) !important; }
}

@media screen and (max-width: 1300px) {
  .turtle-character { left: 34%; top: 24%; width: 500px; height: 500px; }
  .driving-car { width: 700px; left: 3%; bottom: -1%; }
  .rabbit-character { width: 300px; height: 300px; left: 28%; }
  .fly-crow { width: 140px; left: 48%; }
  .title-content h2 { font-size: var(--font-size-4xl) !important; }
  .title-content p { font-size: var(--font-size-4xl) !important; }
}

@media screen and (max-width: 1200px) {
  .left { display: none !important; }
  .right {
    width: 100% !important;
    height: 100%;
    background: var(--color-background);
  }
  .login-pager {
    margin: 0 auto !important;
    max-width: 500px !important;
    padding: var(--font-size-2xl) !important;
  }
  .login-pager > h2 { font-size: var(--font-size-2xl) !important; }
  .login-pager #loginForm > form > input {
    height: 60px !important;
    font-size: var(--font-size-lg) !important;
  }
  .login-pager #loginForm > form > label { font-size: var(--font-size-lg) !important; }
  .login-pager #loginForm > form > button {
    height: 60px !important;
    font-size: var(--font-size-xl) !important;
  }
}

@media screen and (max-width: 768px) {
  .login-container {
    background: linear-gradient(135deg, var(--color-brand) 0%, #1a7fa8 100%) !important;
  }
  .left { display: none !important; }
  .right {
    width: 100% !important;
    height: 100% !important;
    padding: var(--font-size-lg);
    box-sizing: border-box;
  }
  .login-pager {
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 90% !important;
    padding: var(--font-size-2xl) var(--font-size-xl) !important;
    border-radius: var(--font-size-2xl) !important;
  }
  .login-pager-logo > img { width: 56px !important; height: 56px !important; }
  .login-pager > h2 {
    font-size: var(--font-size-2xl) !important;
    margin-bottom: var(--font-size-lg);
  }
  .login-pager #loginForm { width: 100% !important; }
  .login-pager #loginForm > form > input {
    height: 56px !important;
    font-size: var(--font-size-lg) !important;
    padding: var(--font-size-lg) !important;
    border-radius: 12px !important;
  }
  .login-pager #loginForm > form > label {
    font-size: var(--font-size-lg) !important;
    font-weight: 600;
  }
  .login-pager #loginForm > form > button {
    height: 56px !important;
    font-size: var(--font-size-xl) !important;
    margin-top: var(--font-size-2xl) !important;
  }
  .login-pager > p {
    font-size: var(--font-size-md);
    margin-top: var(--font-size-md);
  }
  .login-pager > p > a {
    font-weight: 600;
    color: var(--color-brand);
  }
}

@media screen and (max-width: 480px) {
  .right { padding: var(--font-size-md); }
  .login-pager { padding: var(--font-size-xl) var(--font-size-lg) !important; }
}
</style>